import React, { useMemo } from 'react';
import TableWrapper from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import styles from '@/common/components/Table/styles.less';
import { useToggle } from '@/common/hooks/index';
import cx from 'classnames';
import { TableSortLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Table = ({
  data = [],
  column = [],
  stickyHeader = true,
  rowsNum = null,
  sortBy = '',
  sortOrder = '',
  requestSort = () => {},
  className,
}) => {
  const { t } = useTranslation();
  const [open, toggleOpen] = useToggle(!rowsNum);

  const rows = useMemo(() => {
    let res = data;
    if (!open) res = res.slice(0, rowsNum);
    return res;
  }, [data, open]);

  return (
    <div className={cx(styles.container, className)}>
      <TableWrapper aria-label="simple table" stickyHeader={stickyHeader}>
        <TableHead>
          <TableRow
            sx={{
              '& > th': {
                color: '#666666',
                backgroundColor: 'rgba(250, 249, 247, 1)',
                fontWeight: 400,
                fontSize: '18px',
                lineHeight: '24px',
                fontFamily: 'Red Hat Text',
              },
            }}
          >
            {column.map((title) => {
              if (typeof title === 'string') {
                return <TableCell key={title}>{title}</TableCell>;
              }
              const { sortable, key, label } = title;
              if (sortable) {
                return (
                  <TableCell key={key}>
                    <TableSortLabel
                      key={key}
                      active={sortBy === key}
                      direction={sortOrder}
                      onClick={requestSort(key)}
                    >
                      {label}
                    </TableSortLabel>
                  </TableCell>
                );
              }
              return <TableCell key={key}>{label}</TableCell>;
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(({ key, data, rowProps }) => (
            <TableRow
              key={key}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              {...rowProps}
            >
              {data.map(({ key, value, cellProps }) => (
                <TableCell
                  component="th"
                  scope="row"
                  {...cellProps}
                  key={key || value}
                >
                  {value}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </TableWrapper>
      {rowsNum && rowsNum < data.length && (
        <div className={styles.more}>
          <div
            className={cx(styles.moreBtn, open && styles['moreBtn-active'])}
            onClick={toggleOpen}
          >
            {t('View all')} <ArrowBackIosNewIcon />
          </div>
        </div>
      )}
    </div>
  );
};

export default Table;
